var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { environment } from "../../../../environment";
import { useAuthManagerStore } from "../../stores/authManagerStore/store";
var dsutpMmpidServiceInstance = axios.create({
    baseURL: environment.urlDsutpMmpidService,
});
var dsutpCoreInstance = axios.create({
    baseURL: environment.urlDsutpCore,
});
var dsutpUIDataInstance = axios.create({
    baseURL: environment.urlDsutpUIData,
});
var gatewayInstance = axios.create({
    baseURL: environment.urlGateway,
});
dsutpMmpidServiceInstance.interceptors.request.use(function (config) {
    var token = useAuthManagerStore.getState().userToken;
    config.headers.Authorization = "Bearer ".concat(token);
    return config;
});
dsutpCoreInstance.interceptors.request.use(function (config) {
    var token = useAuthManagerStore.getState().userToken;
    config.headers.Authorization = "Bearer ".concat(token);
    return config;
});
dsutpUIDataInstance.interceptors.request.use(function (config) {
    var token = useAuthManagerStore.getState().userToken;
    config.headers.Authorization = "Bearer ".concat(token);
    return config;
});
gatewayInstance.interceptors.request.use(function (config) {
    var token = useAuthManagerStore.getState().userToken;
    config.headers.Authorization = "Bearer ".concat(token);
    return config;
});
export var getStatistic = function (props) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Statistic/statistic", {
                    params: {
                        objectId: props.id,
                        from: props.from,
                        to: props.to,
                    },
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getConfigurationTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Circuit/types")];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getStatisticByType = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Statistic/count/byType", {
                    params: {
                        objectId: id,
                    },
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getCalcStatuses = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Statistic/calcStatuses", {
                    params: {
                        objectId: id,
                    },
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getPvSvMv = function (_a) {
    var to = _a.to, from = _a.from, id = _a.id;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Statistic/graph/pvsvmv", {
                        params: {
                            objectId: id,
                            from: from,
                            to: to,
                        },
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getValvePositionQuery = function (_a) {
    var to = _a.to, from = _a.from, id = _a.id;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Statistic/graph/valvePosition", {
                        params: {
                            objectId: id,
                            from: from,
                            to: to,
                        },
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getModelInfo = function (name) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Circuit/info/".concat(name))];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getModel = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, gatewayInstance.get("/api/Models/byIdObject", {
                    params: {
                        idObject: id,
                    },
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getAccessList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, gatewayInstance.get("/api/Auth/AccessList")];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getObjectsDiagramsStatsQuery = function (_a) {
    var to = _a.to, from = _a.from, objectsIds = _a.objectsIds;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.post("/api/Statistic/graph/statistic", objectsIds, {
                        params: {
                            from: from,
                            to: to,
                        },
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getObjectsDiagramsErrorQuery = function (_a) {
    var to = _a.to, from = _a.from, id = _a.id;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Statistic/graph/error", {
                        params: {
                            objectId: id,
                            from: from,
                            to: to,
                        },
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getHeatmapObjectStats = function (_a) {
    var from = _a.from, to = _a.to, id = _a.id;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Statistic/hitmap", {
                        params: {
                            objectId: id,
                            from: from,
                            to: to,
                        },
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var postValidateModel = function (model) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.post("/api/Circuit/validate", model)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var postCreateModel = function (model) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.post("/api/Circuit", model)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var putNewModel = function (model) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.put("/api/Circuit", model)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getRecalculation = function (_a) {
    var from = _a.from, to = _a.to, id = _a.id;
    return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Circuit/recalculation", {
                        params: {
                            modelId: id,
                            from: from,
                            to: to,
                        },
                    })];
                case 1:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
};
export var getUIDataConfig = function (_a) {
    var userName = _a.userName, configName = _a.configName;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, parsedSettings;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dsutpUIDataInstance.get("/api/UIData/".concat(userName || "s", "@").concat(configName))];
                case 1:
                    response = (_b.sent()).data;
                    try {
                        parsedSettings = JSON.parse(response.data);
                        response.data = parsedSettings;
                    }
                    catch (error) {
                        console.error(error);
                        throw new Error(error);
                    }
                    return [2 /*return*/, response];
            }
        });
    });
};
export var getObjects = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.get("/api/Objects")];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var postObjects = function (object) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.post("/api/Objects", object)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var putObjects = function (object) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.put("/api/Objects/".concat(object.id), object)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var deleteObjects = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dsutpMmpidServiceInstance.delete("/api/Objects", {
                    params: {
                        id: id,
                    },
                })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
